import { render, staticRenderFns } from "./LearningUploadIcon.vue?vue&type=template&id=909c0924"
import script from "./LearningUploadIcon.vue?vue&type=script&lang=js"
export * from "./LearningUploadIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports